module.exports = __webpack_public_path__ + "img/05.a1250a8f.png";